
import Service from "../domain/Service";

export default {
	props: {
		servicesService: {
			type: Object,
		},
	},
	data() {
		return {
			service: {},
		};
	},
	methods: {
		async saveService(service: Service) {
			await this.servicesService.saveService(service);
			this.$router.push(`/services`);
		},
	},
	created() {
		this.idCustomer = this.$route.params.idCustomer;
	},
};
